<template>
  <Modal :value="true" v-if="popup == 'open'" @close="popup = ''" classContent="upgrade-wall-content">
    <template slot="content">
      <div class="p-20 align-center">
        <div v-if="html != ''" class="py-20" v-html="html"></div>
        <div v-else>
          <img src="@/assets/img/icons/medal.png" alt="" />
          <h6 class="my-20">
            Please upgrade your plan<br />
            to access this feature.
          </h6>
        </div>
        <button class="btn bg-lip color-white color-white-darkmode" @click="upgrade">Upgrade Now</button>
      </div>
    </template>
  </Modal>
</template>

<script>
export default {
  name: "UpgradeWall",
  components: {},
  props: {},
  data: function () {
    return {
      popup: "",
      html: "",
    };
  },
  computed: {
    configs() {
      return this.$store.getters.getMe.configs;
    },
    popups() {
      return this.$store.getters.getMe.upgrade_popups;
    },
  },
  async mounted() {
    this.$root.$on("upgradeWall", (slug, resolve) => {
      let callback = false;
      let config = this.configs.find((c) => c.slug == slug);
      if (config) {
        if (config.data == "yes") {
          callback = true;
        }

        if (callback == false) {
          this.popup = "open";
          let popup = this.popups.find((p) => p.id == config.popup);
          if (popup) {
            this.html = popup.html;
          } else {
            this.html = "";
          }
        }
      }
      resolve(callback);
    });
    this.$root.$on("openUpgradeWall", () => {
      this.popup = "open";
      this.html = "";
    });
  },
  methods: {
    upgrade() {
      this.popup = "";
      this.$root.$emit("toggle-upgrade", true);
    },
  },
};
</script>
